import { configureSlices } from "utils/store/configureSlices";

import locationsSlice from "./locationsSlice";

export const { useSlices: useLocationsSlices, useSliceSelector: useLocationsSliceSelector } = configureSlices({
  locationsSlice,
});
